<template>
    <div>
        <!-- 轮播图 -->
        <div class="bg">
            <div class="sub-title">Cases</div>
            <div class="title">成功案例</div>
        </div>
        <!-- 成功案例 -->
        <div class="" style="margin: 60px 0;">
            <div class="">
                <div v-for="(item, index) in CustomerSolutionData" :key="index" class="flex-column align-center justify-between">
                    <div class="basis-df" @click="showCaseInfo(index)">
                        <img :src="http.ipAddress+item.filePath"
                                style="width: 200px;height: 200px;" alt="">
                    </div>
                    <div class="basis-df" style="margin-left: 20px;position: relative;">
                        <div style="margin-bottom: 20px;">{{item.ettribute1}}</div>
                        <p>{{item.description}}</p>
                        </div>
                        <!-- <img src="../../assets/img/left-11.png" alt="" style="margin-right: 20px;"> -->
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            CustomerSolutionData:[],
                customerCase:[],
                cases: [
                {
                    index:0,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2014年1月",
                    description: "龙工N系列1.5T-3.5T铅酸/锂电平衡重电车，2014年1月份测试通过，并实现量产至今，使用稳定，故障率远远低于千分之一",
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2021年3月",
                    description: "龙工N系列1.5T-3.5T铅酸/锂电平衡重电车、E系列锂电车，2021年3月份测试通过，并实现量产至今，使用稳定，故障率远远低于千分之一",
                    },{
                    img: require("../../assets/img/G2.png"),
                    year: "2023年3月",
                    description: "龙工N2系列1.5T-3.5T铅酸/锂电平衡重电车、E系列锂电车，2023年3月份测试通过，并实现量产至今，使用稳定",
                    },] 
                },{
                    index:1,
                    data:[{
                    img: require("../../assets/img/controller/V2总成合力.jpg"),
                    year: "2017年3月",
                    description: "合力H系列1.5-3.8吨交流电动叉车，2017年3月测试通过，并实现量产，故障率低于1500ppm,性能优异，处于国际领先水准。此外出口欧美亚洲等地。"
                    },{
                    img: require("../../assets/img/controller/V2总成合力.jpg"),
                    year: "2019年5月",
                    description: "合力G系列锂电专用车和三支点锂电叉车，2019年5月测试通过，并实现量产，故障率低于1500ppm,性能优异，处于国际领先水准。此外出口欧美亚洲等地。"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2021年2月",
                    description: "合力G2系列锂电专用车，2020年10月测试通过，并实现量产至今（叉车），故障率低于1500ppm,性能优异，处于国际领先水准。此外出口欧美亚洲等地。"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "2022年4月",
                    description: "合力G系列1.5-6吨交流电动牵引车，2022年4月测试通过，并实现量产至今（牵引车），故障率低于1500ppm,性能优异，处于国际领先水准。此外出口欧美亚洲等地。"
                    },] 
                },{
                    index:2,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2020年",
                    description: "HDK全系列出口高尔夫球车，2020年测通过，量产至今，全部出口海外，售后反馈优于欧美品牌表现"
                    },] 
                },{
                    index:3,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2021年",
                    description: "徐工高机16米-45米全系列直曲臂，2021年测试通过，量产至今，客户满意高，完全替代欧美产品"
                    },{
                    img: require("../../assets/img/S1X.png"),
                    year: "2023年",
                    description: "徐工剪叉全系列，2023年测试通过，量产至今，客户满意高，完全替代欧美产品"
                    },] 
                },{
                    index:4,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2015年10月",
                    description: "  KBE系列1.5-3.5吨全交流电动叉车,2015年10月测试通过，并实现量产，第一代成功替代进口"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2019年10月",
                    description: " KBE系列三支点电动叉车,2019年10月测试通过，并实现量产"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2021年10月",
                    description: " KBE系列1.5T-2.0T 出口车,2021年10月测试通过，并实现量产,满足最新的EN1175双芯片认证，大量出口欧洲市场，从未接到客诉。"
                    }
                ] 
                },{
                    index:5,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2020年1月",
                    description: "比亚迪E-C系列2.5吨交流电动叉车，2020年1月搭载通过，并实现量产至今,质量稳定，同类产品中故障率最低"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "2021年5月",
                    description: "比亚迪F系列3吨交流电动叉车，2021年1月搭载通过，并实现量产至今,质量稳定，同类产品中故障率最低"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2022年9月",
                    description: "比亚迪EL系列2~3.5吨交流电动叉车，2022年9月搭载通过，并实现量产至今,质量稳定，同类产品中故障率最低"
                    }
                ] 
                },{
                    index:6,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2020年",
                    description: "林德多向前移车，2020年测试通过，并实现量产至今,客户满意，无一起异常反馈"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2022年",
                    description: "林德3-3.5T平衡重叉车，2022年测试通过，并实现量产至今,对比进口品牌节能18%"
                    },
                ] 
                },{
                    index:7,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "2021年",
                    description: "柳工轻量化平衡重叉车，2021年测试通过，量产至今，大批量出口海外，市场故障率低于竞品"
                    }
                ] 
                },{
                    index:8,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2022年5月",
                    description: "2座、4座、6座高尔夫球车/打猎车，2022年5月份测试通过，并实现量产至今，使用稳定，故障率远远低于千分之一"
                    },
                ] 
                },{
                    index:9,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "2019年5月",
                    description: "玛西尔DN系列14~23座观光车，2019年5月搭载通过，并实现量产至今，替代柯蒂斯，收到国内外客户一直好评，并持续不断地应用到多种车型上"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "2021年4月",
                    description: "玛西尔EV系列4~6座高尔夫球车，2021年4月搭载通过，并实现量产至今，替代柯蒂斯，收到国内外客户一直好评，并持续不断地应用到多种车型上"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "2022年4月",
                    description: "玛西尔悍马系列4~8座巡逻车，2022年4月搭载通过，并实现量产至今，替代柯蒂斯，收到国内外客户一直好评，并持续不断地应用到多种车型上"
                    }
                ] 
                },{
                    index:10,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2017年8月",
                    description: "台励福1.5-3.5吨全交流电动叉车，2017年8月测试通过，并实现量产，第一代成功替代进口"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2020年8月",
                    description: "台励福1.5-3.5吨全交流电动叉车，2020年8月测试通过，并实现量产，第二代成为主力配套"
                    },{
                    img: require("../../assets/img/G2.png"),
                    year: "2023年8月",
                    description: "台励福油改电系列3.5吨全交流电动叉车，2023年8月测试通过，并实现量产，二合一电控性能可靠，同等电流相比于进口品牌能耗低"
                    }
                ] 
                },{
                    index:11,
                    data:[{
                    img: require("../../assets/img/S1.png"),
                    year: "2022年6月",
                    description: "2座、4座、6座高尔夫球车/打猎车，2022年6月份测试通过，并实现量产至今，使用稳定，性能和质量表现达到国际同类水平"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "2022年8月",
                    description: "高尔夫球车 2+2  4+2，2022年8月测试通过，并且量产，性能和质量表现达到国际同类水平"
                    }
                ] 
                },{
                    index:12,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "2021年",
                    description: "福龙马乘驾驶道路清扫车系列，2021年测试通过，量产至今,客户满意，无一起异常反馈"
                    },
                ] 
                },{
                    index:13,
                    data:[{
                    img: require("../../assets/img/G1.png"),
                    year: "2023年5月",
                    description: "E800清洗环卫车，2023年5月份测试通过，并实现量产至今，使用稳定，目前没有故障"
                    },{
                    img: require("../../assets/img/G2.png"),
                    year: "2023年5月",
                    description: "E800清洗环卫车，2023年5月份测试通过，并实现量产至今，使用稳定，目前没有故障"
                    }
                ] 
                },{
                    index:14,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "2021年10月",
                    description: "中力油改电系列2.0T-3.5T锂电车，2021年10月份测试通过，并实现量产至今，使用稳定，故障率远远低于千分之一"
                    }
                ] 
                },{
                    index:15,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2018年",
                    description: "中联1.5-3.5吨电动叉车，2018年测试通过，批量至今，市场无异常反馈，优于同行"
                    },{
                    img: require("../../assets/img/D1.png"),
                    year: "2020年",
                    description: "中联1.5-3.5吨电动叉车，2020年测试通过，批量至今，市场无异常反馈，优于同行"
                    },{
                    img: require("../../assets/img/S1.png"),
                    year: "2022年",
                    description: "中联直曲臂车，2022年测试通过，批量至今，市场无异常反馈，优于同行"
                    }
                ] 
                 },{
                    index:16,
                    data:[{
                    img: require("../../assets/img/D1.png"),
                    year: "2021年5月",
                    description: "朗晴14~23座观光车，2021年5月搭载通过，并实现量产至今，替代柯蒂斯，故障率低"
                    }
                 ] 
                 }
                ,{
                    index:17,
                    data:[{
                    img: require("../../assets/img/V2.png"),
                    year: "2017年",
                    description: "杭叉A系列交流电动叉车，2017年测试通过并实现量产"         
                    }
                ] 
                },

                
                
                ],
        selectedCase: {
               
        }
            
            
        }
    },
    methods: {
        showCaseInfo(index) {
        this.selectedCase = this.cases[index];
        }
    },
    mounted() {
        console.log('index', this.$route.query.index);
        let index =  this.$route.query.index;
        let that=this;
       
        this.http.post("/api/FJ_CustomerSolution/GetCustomerSolution?customerid="+parseInt(index,10),JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                that.CustomerSolutionData=objResult.data;
            }
        });
       
        // this.http.post("/api/FJ_CustomerSolution/GetCustomerSolution?customerid="+parseInt(index,10),JSON.stringify({})).then((result)=>{
        //     debugger
        //    let objResult= eval(result);
        //    let iCode= objResult.code;
        //    if(iCode==0){
        //         that.CustomerSolutionData=objResult.data;
        //     }
        // });
        
    }
}
</script>


<style scoped>
.bg {
    background: url('../../assets/img/casesbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}
.cases-item {
    width: 33.3%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #eee;
}

.cases-item:nth-child(3n - 1) {
    border-left: none;
    border-right: none;
}

/* .products-item.active {
    border-color: #0AA00A;
} */
</style>


// WEBPACK FOOTER //
// src/views/cases/m_detail.vue